import { v4 as uuidv4 } from 'uuid';
import img1 from '../../assets/img/project/project1.jpg';
import img2 from '../../assets/img/project/project2.jpg';
import img3 from '../../assets/img/project/project3.jpg';
import img4 from '../../assets/img/project/project4.jpg';
import img5 from '../../assets/img/event/1.jpg';
import img6 from '../../assets/img/event/lab-activitis/lab-activity-02.jpg';
import img7 from '../../assets/img/banners/13.png';
import img8 from '../../assets/img/banners/14.png';
import img9 from '../../assets/img/event/electroporator.jpeg';


const projectFilterData = [
    {
        id: uuidv4(),
        image: img7,
        heading: 'Cytocare Events',
        category: 'events',
    },

    {
        id: uuidv4(),
        image: img8,
        heading: 'Cytocare Events',
        category: 'events',
    },
    
    {
        id: uuidv4(),
        image: img1,
        heading: 'EBMT - 2018',
        category: 'events',
        link: "/ebmt-event"
    },

    {
        id: uuidv4(),
        image: img2,
        heading: 'CliniMACS Devices',
        category: 'equipments',
        link: false
    },

    {
        id: uuidv4(),
        image: img3,
        heading: 'Clinical Reagents',
        category: 'medicine',
        link: false
    },

    {
        id: uuidv4(),
        image: img4,
        heading: 'Cytocare Experiments',
        category: 'experiments',
        link: false
    },

    {
        id: uuidv4(),
        image: img5,
        heading: 'Cytocare Events',
        category: 'events',
        link: "/cytocare-event-1"
    },

    {
        id: uuidv4(),
        image: img6,
        heading: 'Cytocare Events',
        category: 'events',
        link: "/cytocare-event-2"
    },
    {
        id: uuidv4(),
        image: img9,
        heading: 'CliniMACS Electroporator',
        category: 'events',
    },
];

export default projectFilterData;
